if (!Number.isNan) {
	Object.defineProperty(Number, 'isNaN', {
		value: function(value) {
			return value !== value;
		}
	});
}
// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function noop() {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

const Utils = {
	// limit the number of times a function can be run within a given time frame
	debounce: function(func, wait, immediate) {
		let timeout;
		return function() {
			let context = this, args = arguments;
			let later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			let callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	},
	getURLParameter: function(name) {
		const rgexp = new RegExp(name + '=' + '(.+?)(&|$)');
		return decodeURIComponent( (rgexp.exec(window.location.search)||[,""])[1] );
	},
	getRandomInt: function(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	},
	getRandomArbitrary: function (min, max) {
		return Math.random() * (max - min) + min;
	},
	isTouchDevice: function(){
		if ('ontouchstart' in document.documentElement) {
			return true;
		}
		return false;
	},
	isRetina: function(){
		const mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\
            (min--moz-device-pixel-ratio: 1.5),\
            (-o-min-device-pixel-ratio: 3/2),\
            (min-resolution: 1.5dppx)";
		if (window.devicePixelRatio > 1) {
			return true;
		}
		if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
			return true;
		}
		return false;
	},
	arrayShuffle: function(array) {
		let i = 0
			, j = 0
			, temp = null;

		for (i = array.length - 1; i > 0; i -= 1) {
			j = Math.floor(Math.random() * (i + 1));
			temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
	},
	centeredPopup: function (url, title, w, h) {
		// Fixes dual-screen position Most browsers Firefox
		const dualScreenLeft = (typeof window.screenLeft !== 'undefined') ? window.screenLeft : screen.left;
		const dualScreenTop = (typeof window.screenTop !== 'undefined') ? window.screenTop : screen.top;
		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const left = ((width / 2) - (w / 2)) + dualScreenLeft;
		const top = ((height / 2) - (h / 2)) + dualScreenTop;
		const newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

		// Puts focus on the newWindow
		if ( window.focus ) {
			newWindow.focus();
		}
	},
	isFunction: function(functionToCheck) {
		return ( functionToCheck && {}.toString.call(functionToCheck) === "[object Function]" );
	},
	validEmail: function(email) {
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	},
	getSiblings: function(elem) {
		// Setup siblings array and get the first sibling
		const siblings = [];
		let sibling = elem.parentNode.firstChild;

		// Loop through each sibling and push to the array
		while (sibling) {
			if (sibling.nodeType === 1 && sibling !== elem) {
				siblings.push(sibling);
			}
			sibling = sibling.nextSibling
		}

		return siblings;
	}
};
